import React, { useState } from "react";

const PreviewImage = ({ file }) => {
  const [preview, setPreview] = useState(null);

  const reader = new FileReader();

  reader.onload = () => {
    setPreview(reader.result);
  };

  if (file) {
    reader.readAsDataURL(file);
  }

  return (
    <div>
      <img src={preview} alt="preview" width="200px" height="200px" />
    </div>
  );
};

export default PreviewImage;
